module.exports = __webpack_public_path__ + "img/top-bar.d919838b.png";